/** Color, Please data loading. The interface imports only the original color
 * rules and preview jobs; the separate Type Set library is not a dependency. */

import colourRules from "@data/legacy/color-please/recommendation-rules.v1.json";
import previewTemplates from "@data/legacy/color-please/preview-templates.v1.json";

import type {
  ColourCoreQuestion,
  ExportContentProfile,
  PreviewFieldSpec,
  PreviewTemplate,
  SamplePack,
} from "./types";

const colourRulesDoc = colourRules as unknown as {
  quickPath: { actionLabel: string; resultStatus: string; allowWithoutAnsweredQuestions: boolean; discloseEveryDefault: boolean };
  coreQuestions: ColourCoreQuestion[];
};

export const colourQuickPath = colourRulesDoc.quickPath;
export const colourCoreQuestions = colourRulesDoc.coreQuestions;

const templatesDoc = previewTemplates as unknown as {
  interfaceRoleLabels: Record<string, { label: string; explanation: string }>;
  fields: Record<string, PreviewFieldSpec>;
  fitStatuses: Array<{ id: string; meaning: string }>;
  templates: PreviewTemplate[];
  samplePacks: SamplePack[];
  exportContentProfiles: Record<string, ExportContentProfile>;
};

export const roleLabels = templatesDoc.interfaceRoleLabels;
export const previewFieldSpecs = templatesDoc.fields;
export const fitStatusMeanings = templatesDoc.fitStatuses;
export const previewTemplateList = templatesDoc.templates;
export const samplePacks = templatesDoc.samplePacks;
export const exportContentProfiles = templatesDoc.exportContentProfiles;

export const colourQuestion = (id: ColourCoreQuestion["id"]): ColourCoreQuestion | null =>
  colourCoreQuestions.find((question) => question.id === id) ?? null;
